import styled from "styled-components";

const Container = styled.div`
  svg {
    fill: white;
  }
`;

export { Container };